import { useMutation, useQueryClient } from 'react-query';
import { ProjectEstimateService as es } from '../api/ProjectEstimateService';
import { useStore } from 'zustand';
import { useUnityBuildStore } from '../stores/store';
import { Estimate } from '../api/protosCompiled/projectEstimate/projectEstimate_pb';

export const useCreateEstimateMutation = () => {
  const queryClient = useQueryClient();
  const { selectedProject } = useStore(useUnityBuildStore);

  return useMutation((data: any) => es.createProjectEstimate(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(['estimates', selectedProject?.id]);
      queryClient.invalidateQueries(['contracts', selectedProject?.id]);
    },
    onError: error => {
      console.error('Error creating estimate', error);
    },
  });
};

export const useUpdateEstimateMutation = () => {
  const queryClient = useQueryClient();
  const { selectedProject } = useStore(useUnityBuildStore);

  return useMutation((data: any) => es.updateProjectEstimate(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(['estimates', selectedProject?.id]);
      queryClient.invalidateQueries(['contracts', selectedProject?.id]);
    },
    onError: error => {
      console.error('Error updating estimate', error);
    },
  });
};

export const useDeleteEstimateMutation = () => {
  const queryClient = useQueryClient();
  const { selectedProject } = useStore(useUnityBuildStore);

  return useMutation((data: Estimate.AsObject) => es.deleteProjectEstimate(data.estimateid), {
    onSuccess: () => {
      queryClient.invalidateQueries(['estimates', selectedProject?.id]);
      queryClient.invalidateQueries(['contracts', selectedProject?.id]);
    },
    onError: error => {
      console.error('Error deleting estimate', error);
    },
  });
};
